import * as React from "react";

import {
  CustomerGroupFilterState,
  DashboardFilterState,
  GlassFiberFilter,
  ProductType,
  Tariff,
  TernaryFilterOption,
} from "../../../types/index";
import { FilterGroup } from "../constants";
import FilterContainer from "../FilterContainer";
import CustomerTariffsFilter from "./CustomerTariffsFilter";
import { ContractExistingOptions } from "./FilterOptions";
import ProductFamilyFilter from "./ProductFamilyFilter";

interface Props {
  glassFiberFilter: GlassFiberFilter;
  superordinateFilter: "CustomerGroupFilter" | "DashboardFilter";
  enabled: boolean;
  changeFilter: (
    payload: Partial<CustomerGroupFilterState> | Partial<DashboardFilterState>
  ) => void;
  handleEnabledChange: (filterGroup: FilterGroup, enabled: boolean) => void;
}

class GlassFiberFilterComponent extends React.Component<Props> {
  private changeGlassFiberFilter = (
    changedPartsGlassFiberFilter: Partial<GlassFiberFilter>
  ) => {
    this.props.changeFilter({
      glassFiberFilter: {
        ...this.props.glassFiberFilter,
        ...changedPartsGlassFiberFilter,
      },
    });
  };

  private changeContractFilter = (filter: TernaryFilterOption) => {
    this.changeGlassFiberFilter({ contractExistingFilter: filter });
  };

  private changeFilterEnabled = (enabled: boolean) => {
    this.props.handleEnabledChange(FilterGroup.glassFiber, enabled);
  };

  private changeTariffsFilter = (tariffs: Tariff[]) => {
    this.changeGlassFiberFilter({ tariffs });
  };

  private changeProductFamiliesFilter = (productFamilies: string[]) => {
    const filteredTariffs = productFamilies.length
      ? this.props.glassFiberFilter.tariffs.filter((tariff) =>
          productFamilies.includes(tariff.productFamily)
        )
      : this.props.glassFiberFilter.tariffs;

    this.changeGlassFiberFilter({
      productFamilies,
      tariffs: filteredTariffs,
    });
  };

  public render(): JSX.Element {
    return (
      <FilterContainer
        title="Glasfaserverträge"
        enabled={this.props.enabled}
        onEnabledChange={this.changeFilterEnabled}
      >
        {(disabled?: boolean) => (
          <>
            <ContractExistingOptions
              contractExistingFilterState={
                this.props.glassFiberFilter.contractExistingFilter
              }
              onChange={this.changeContractFilter}
              disabled={disabled}
            />
            {this.props.superordinateFilter === "CustomerGroupFilter" && (
              <ProductFamilyFilter
                productTypeFilter={this.props.glassFiberFilter}
                onChange={this.changeProductFamiliesFilter}
                productType={ProductType.GLASS_FIBER}
              />
            )}
            {this.props.superordinateFilter === "CustomerGroupFilter" && (
              <CustomerTariffsFilter
                productTypeFilter={this.props.glassFiberFilter}
                onChange={this.changeTariffsFilter}
                productType={ProductType.GLASS_FIBER}
                disabled={disabled}
              />
            )}
          </>
        )}
      </FilterContainer>
    );
  }
}

export default GlassFiberFilterComponent;



// WEBPACK FOOTER //
// ./src/components/Filters/ProductTypeFilter/GlassFiberFilter.tsx